<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-paraa"><a id="page_iv"></a>Farrar, Straus and Giroux<br/>18 West 18th Street, New York 10011</p>
<p class="center-paraa">Copyright © 2005 by Éditions Gallimard<br/>Translation copyright © 2010 by Mitzi Angel<br/>All rights reserved<br/>Distributed in Canada by D&amp;M Publishers, Inc.<br/>Printed in the United States of America<br/>Originally published in 2005 by Éditions Gallimard, France<br/>Published in the United States by Farrar, Straus and Giroux<br/>First American edition, 2010</p>
<p class="center-paraa">Library of Congress Cataloging-in-Publication Data</p>
<p class="paraa">Valtat, Jean-Christophe, 1968–</p>
<p class="indent-paraa">[03. English]</p>
<p class="indent-paraa">03 / Jean-Christophe Valtat ; [translated from the French by Mitzi Angel]. — 1st American ed.</p>
<p class="indent-paraa">      p. cm.</p>
<p class="indent-paraa">ISBN: 978-0-374-10021-6 (pbk. : alk. paper)</p>
<p class="indent-paraa">1. Teenage boys—Fiction. 2. Teenage girls—Fiction. 3. Teenagers with disabilities—Fiction. 4. Adolescence—Fiction. I. Angel, Mitzi. II. Title. III. Title: Zero 3. IV. Title: Zero three.</p>
<p class="parab">PQ2682.A438O1813 2010</p>
<p class="parab">844'.92—dc22</p>
<p class="right-paraa">2010012616</p>
<p class="center-paraa">Designed by Jonathan D. Lippincott</p>
<p class="center-paraa"><a href="http://www.fsgbooks.com" target="_blank">www.fsgbooks.com</a></p>
<p class="center-paraa">1   3   5   7   9   10   8   6   4   2</p>
<p class="para"> </p>
<p class="paraa">This work, published as part of a program providing publication assistance, received financial support from the French Ministry of Foreign Affairs, the Cultural Services of the French Embassy in the United States, and FACE (French American Cultural Exchange).</p>
<p class="image"><img alt="" src="images/copy.jpg"/></p>
<p class="paraa"><em>Cet ouvrage a bénéficié du soutien des Programmes d’aide à la publication de Culturesfrance/Ministére français des affaires éstrangères et europèennes.</em> (This work, published as part of a program of aid for publication, received support from CulturesFrance and the French Ministry of Foreign Affairs.)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?009591ac